<h2 mat-dialog-title>KPI</h2>
<div mat-dialog-content class="dialog-center-cont">
  <app-spinner-overlay></app-spinner-overlay>
  <form [formGroup]="formKPI" appFormContainer [larghezza]="6">
    <mat-form-field appFormElement [larghezza]="3" [riempi]="true">
      <mat-label>Nome Breve</mat-label>
      <input matInput placeholder="Nome Breve" formControlName="nomeBreve" />
      <mat-error appFormError></mat-error>
    </mat-form-field>

    @if (isConfigurazione) {
      <mat-form-field class="input-form" appFormElement [larghezza]="3" [riempi]="true">
        <mat-label>Settori</mat-label>
        <mat-select
          formControlName="settori"
          placeholder="Settori"
          [(value)]="selectedSettori"
          multiple
          [compareWith]="compareSettori"
        >
          @for (settore of arraySettori; track $index) {
            <mat-option [value]="settore">{{ settore.titolo }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <mat-form-field appFormElement [larghezza]="6" [riempi]="true">
      <mat-label>Descrizione</mat-label>
      <textarea
        matInput
        placeholder="Descrizione"
        formControlName="descrizione"
        rows="4"
      ></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>

    @if (isKpiCreatoDaContesto) {
      <ng-container>
        <app-autocomplete
          appFormElement
          [larghezza]="3"
          [riempi]="true"
          formControlName="idCategoriaUnitaDiMisura"
          [label]="'Categorie'"
          [loadDataFn]="getCategorie"
          [displayFn]="displayFn"
          [compare]="compareCategorie"
          (recordChange)="getUnitaDiMisura($event)"
          [required]="true"
          [chiaveId]="'id'"
          [numeroRecOptions]="infiniteRecords"
        >
        </app-autocomplete>

        <mat-form-field class="input-form" appFormElement [larghezza]="3" [riempi]="true">
          <mat-label>Unità di Misura di Riferimento</mat-label>
          <mat-select
            formControlName="idUnitaDiRiferimento"
            placeholder="Unità di Misura di Riferimento"
            [(value)]="selectedUnitaDiMisura"
            [compareWith]="compareUnitaDiMisura"
          >
            @for (um of arrayUnitaDiMisura; track $index) {
              <mat-option [value]="um">{{ um.descrizione }}</mat-option>
            }
          </mat-select>
          <mat-error appFormError></mat-error>
        </mat-form-field>
      </ng-container>
    }

    @if (isConfigurazione) {
      <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
        <mat-label>TAG</mat-label>
        <input matInput placeholder="TAG" formControlName="tag" />
        <mat-error appFormError></mat-error>
      </mat-form-field>

      <div appFormElement [larghezza]="4" [riempi]="true">
        <button
          mat-stroked-button
          (click)="opeDialogTarget()"
          [matBadge]="selectedStdr.length || 0"
          class="stdr-button"
        >
          Configurazione Standard di Rendicontazione, Compliance Normativi e Target
        </button>
      </div>
    }

    @if (!isConfigurazione) {
      @if (this.formKPI.get('note')?.value || mostraNote) {
        <mat-form-field appFormElement [larghezza]="6" [riempi]="true">
          <mat-label>Note per il compilatore</mat-label>
          <textarea
            matInput
            placeholder="Note per il compilatore"
            formControlName="note"
            rows="4"
          ></textarea>
          <mat-error appFormError></mat-error>
        </mat-form-field>
      }
      @if (!this.formKPI.get('note')?.value) {
        <button mat-stroked-button class="bottone-note-compilatore" (click)="mostraNoteFn()">
          <mat-icon class="material-icons-outlined"> {{ mostraNote ? 'remove' : 'add' }}</mat-icon>
          {{ mostraNote ? 'Nascondi' : 'Assegna' }} note per il compilatore
        </button>
      }
    }
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="salvaInHtml()" class="primary-button">
      Salva
    </button>
  </div>
  @if (isConfigurazione) {
    <div>
      <button mat-flat-button (click)="ctrOpenPromptAI()" class="ai-button">
        <mat-icon>auto_awesome</mat-icon>Prompt AI
      </button>
    </div>
  }
</div>
